<p-blockUI [target]="pblockableDiv" [blocked]="loginBlocked"></p-blockUI>
<app-blockable-div #pblockableDiv>
    <!-- Login Panel -->
    <form [formGroup]="loginForm" (change)="setModel()">

        <!-- Tel or Mail -->

        <div class="form-group my-2">
            <span class="p-field w-full p-input-icon-right">
                <i class="pi pi-user"></i>
                <input pInputText formControlName="userMailOrPhone"
                    [placeholder]="'LOGIN.ENTER_MAIL_OR_PHONE' | translate " name="phoneOrMail" style="width: inherit;" />
            </span>
        </div>

        <!-- Password -->

        <password placeholder="LOGIN.ENTER_PASSWORD" controlName="password" [action]="submitForm.bind(this)" style="width: inherit;"></password>

        <!------ VERIFICATION ------>
        <div *ngIf="verificationRequired" #verification>

            <!------ MAIL VERIFICATION ------>
            <p-button type="button" icon="" iconPos="right" [disabled]="!loginForm.valid"
                [label]="'LOGIN.MESSAGES.EMAIL_VERIFICATION'|translate" (click)="onMailVerficationClicked()"
                class="p-button-raised p-button-text p-button-plain" #mailVerification></p-button>
        </div>
    </form>
</app-blockable-div>
